export default { 
  h83478d16454d2e04d7d6a86eef7977f3: [[({}, [C0, C1]) => ["\xA9 ", C0(), " ", C1()], {}]] 
}